import { asyncScheduler } from 'rxjs';
import { AfterViewInit, Component, Inject, OnDestroy, OnInit, PLATFORM_ID, Renderer2, ViewEncapsulation } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { OktaAuth } from '@okta/okta-auth-js';
import * as OktaSignIn from '@okta/okta-signin-widget';

import { EnvironmentService } from '@app/environments/services/environment.service';

@Component({
  encapsulation: ViewEncapsulation.None,
  styleUrls: [
    './login.component.scss',
  ],
  templateUrl: './login.component.html'
})
export class LoginComponent implements AfterViewInit, OnInit, OnDestroy {

  signIn: OktaAuth;
  widget: any;

  constructor(
    @Inject(DOCUMENT)
    private document: Document,

    @Inject(PLATFORM_ID)
    private platformId: object,

    private readonly environmentService: EnvironmentService,
    private readonly oktaAuthService: OktaAuth,
    private readonly renderer: Renderer2,
  ) {
    this.signIn = this.oktaAuthService;

    this.widget = new OktaSignIn({
      authParams: {
        pkce: this.environmentService.environment.okta.pkce,
      },
      baseUrl: this.environmentService.environment.okta.issuer,
      logo: 'assets/svg/login-logo.svg',
    });
  }

  ngOnInit(): void {
    asyncScheduler.schedule(() => {
      this.widget.renderEl({
        el: '#okta-signin-container'},
        (res) => {
          if (res.status === 'SUCCESS') {
            this.signIn.signInWithRedirect({
              originalUri: '/portal',
              sessionToken: res.session.token
            });
            // Hide the widget
            this.widget.hide();
          }
        },
        (err) => {
          throw err;
        }
      );

      this.updateOktaWidgetText();
    }, 0);

  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.renderer.addClass(this.document.querySelector('body'), 'login');
    }
  }

  ngOnDestroy(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.renderer.removeClass(this.document.querySelector('body'), 'login');
    }
  }

  updateOktaWidgetText(): void {
    asyncScheduler.schedule(() => {
      document.getElementById('okta-signin-submit').setAttribute('style', 'background: #3A5CE9;');
      document.querySelector('.auth-org-logo').setAttribute('style', 'max-width: 90%');
    }, 100);
  }

}
